import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { PageTitle } from '../../../_metronic/layout/core';
import DistributorDetail from '../../modules/distributors/components/DistributorDetail';
import DistributorAddresses from '../../modules/distributors/components/DistributorAddresses';
import DistributorFiles from '../../modules/distributors/components/DistributorFiles';
import DistributorPointsOfSale from '../../modules/distributors/components/DistributorPointsOfSale';

type RouteParams = {
  distributorId: string;
};

const DistributorDetailPage: FC = () => {
  const intl = useIntl();
  const { distributorId } = useParams<RouteParams>();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'distributorDetail.title' })}
      </PageTitle>
      <div className="d-flex justify-content-end mb-4">
        <Link
          to={`/distributor/${distributorId}/logs`}
          className="btn btn-primary"
        >
          <i className="bi bi-clock-history me-2" />
          {intl.formatMessage({ id: 'logs.seeLogs' })}
        </Link>
      </div>
      <div className="row">
        <div className="col-6 d-flex flex-column gap-8">
          <DistributorDetail id={distributorId} />
          <DistributorFiles id={distributorId} />
        </div>
        <div className="col-6 d-flex flex-column gap-8">
          <DistributorAddresses id={distributorId} />
          <DistributorPointsOfSale id={Number(distributorId)} />
        </div>
      </div>
    </>
  );
};

export { DistributorDetailPage };
